export enum CombinedViews {
  List = 'List',
  Combined = 'Combined',
  Calendar = 'Calendar',
}
